import React from "react";
import { List, useTable } from "@refinedev/antd";
import { Table, Space, Button, Tag, Tooltip, message } from "antd";
import { ITextTemplate } from "../../interfaces";
import { useHashNavigation } from "../../hooks/useHashNavigation";
import { EditOutlined, EyeOutlined, CopyOutlined, PlusOutlined } from "@ant-design/icons";

export const TemplateList: React.FC = () => {
  const { navigateWithHash } = useHashNavigation();
  const { tableProps } = useTable<ITextTemplate>();

  const getTypeTag = (type: string) => {
    const typeConfig: Record<string, { color: string; label: string }> = {
      standard: { color: "green", label: "Standard" },
      storno: { color: "red", label: "Storno" },
      noshow: { color: "orange", label: "No-Show" },
      reminder: { color: "blue", label: "Mahnung" },
      confirmation: { color: "cyan", label: "Bestätigung" },
    };

    const config = typeConfig[type] || { color: "default", label: type };
    return <Tag color={config.color}>{config.label}</Tag>;
  };

  const handleShow = (record: ITextTemplate) => {
    // Anzeige-Logik für Templates
    message.info(`Anzeigen von Template "${record.title}" wird implementiert...`);
  };

  const handleEdit = (record: ITextTemplate) => {
    // Bearbeiten-Logik für Templates
    message.info(`Bearbeiten von Template "${record.title}" wird implementiert...`);
  };

  const handleCopy = (record: ITextTemplate) => {
    // Kopier-Logik für Templates
    message.success(`Template "${record.title}" wurde kopiert!`);
  };

  return (
    <List 
      title="Textbausteine"
      headerButtons={[
        <Button
          key="create"
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => message.info('Neuen Textbaustein erstellen wird implementiert...')}
        >
          Neuer Textbaustein
        </Button>,
      ]}
    >
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="title"
          title="Titel"
          sorter
          render={(value) => <strong>{value}</strong>}
        />
        <Table.Column
          dataIndex="type"
          title="Typ"
          render={(value) => getTypeTag(value)}
        />
        <Table.Column
          dataIndex="content"
          title="Inhalt"
          render={(value) => (
            <span title={value}>
              {value.length > 100 ? `${value.substring(0, 100)}...` : value}
            </span>
          )}
        />
        <Table.Column
          title="Aktionen"
          dataIndex="actions"
          width={150}
          render={(_, record: ITextTemplate) => (
            <Space>
              <Tooltip title="Anzeigen">
                <Button
                  size="small"
                  icon={<EyeOutlined />}
                  onClick={() => handleShow(record)}
                />
              </Tooltip>
              <Tooltip title="Bearbeiten">
                <Button
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(record)}
                />
              </Tooltip>
              <Tooltip title="Kopieren">
                <Button
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={() => handleCopy(record)}
                />
              </Tooltip>
            </Space>
          )}
        />
      </Table>
    </List>
  );
}; 